import React from "react";
import { Link } from "react-router-dom";
import { PackageSearch } from "lucide-react";

export default function ProductDetailState({ loading, error, missingContext, onRetry }) {
  if (loading) return <section className="productdetail-section" role="status" aria-live="polite">
    <span className="visually-hidden">Loading product details...</span>
    <div className="container container-lg productdetail-layout productdetail-loading" aria-hidden="true">
      <div className="productdetail-loading__gallery" />
      <div className="productdetail-loading__content">
        <div className="productdetail-loading__line" /><div className="productdetail-loading__line is-short" />
        <div className="productdetail-loading__button" /><div className="productdetail-loading__line" />
        <div className="productdetail-loading__panel" /><div className="productdetail-loading__panel" />
      </div>
    </div>
  </section>;

  return <section className="productdetail-state container container-lg">
    <span className="productdetail-state__icon"><PackageSearch size={36} aria-hidden="true" /></span>
    <h1>{error ? "Unable to load product" : missingContext ? "Choose a product" : "Product not found"}</h1>
    <p role={error ? "alert" : undefined}>{error || (missingContext ? "Open a product from a store to see its details." : "This product is currently unavailable. Explore more products from our stores.")}</p>
    <div className="productdetail-state__actions">
      {onRetry && <button type="button" onClick={onRetry}>Try again</button>}
      <Link to="/home">Browse services</Link>
    </div>
  </section>;
}
